<template>
  <DialogDef2 :show="true" :label="'編輯使用者'" :width="582" @close="$emit('close')">
    <div class="addemp">
      <div class="field">
        <div>員工姓名</div>
        <input type="text" :style="{width: '295px'}" v-model="editItem.name">
      </div>
      <div class="field">
        <div>隸屬部門</div>
        <input type="text" :style="{width: '295px'}" v-model="editItem.department">
      </div>
      <div class="field">
        <div>職位</div>
        <input type="text" :style="{width: '295px'}" v-model="editItem.title">
      </div>
      <div class="field">
        <div>ERP編號</div>
        <input type="text" :style="{width: '295px'}" v-model="editItem.erpID">
      </div>
      <div class="field">
        <div>電話</div>
        <input type="text" :style="{width: '295px'}" v-model="editItem.mobile" :placeholder="'(請輸入10碼純數字)'">
      </div>
      <div class="field">
        <div>角色權限</div>
        <Select1 width="295px" :defaultValue="editItem.role" @input="editItem.role=$event">
          <option v-for="k in rolemap" :key="k" :value="k.key">{{k.zh}}</option>
        </Select1>
      </div>
      <div class="field">
        <div>LINE</div>
        <div class="user-box" v-if="editItem.ref_uid&&editItem.ref_uid._id">
          <div>{{editItem.ref_uid.lineName}}</div><button @click="editItem.ref_uid={}" class="removebtn"></button></div>
          <label v-else for="user-input">
            <input type="text" id="user-input" v-model="userText">
            <div class="ul" v-if="uldisplay">
              <div class="li" @click="uldisplay=false;editItem.ref_uid={}"><div>不設定</div></div>
              <div class="li" v-for="(ag, j) in users" :key="`agency-${j}`"
              @click="editItem.ref_uid=JSON.parse(JSON.stringify(ag))">
              <div>{{ag.lineName || '------------'}}</div>
              <div :style="{borderLeft: '1px solid', paddingLeft: '10px'}">{{ag.name}}</div></div>
            </div>
          </label>
      </div>
      <BtnsS :style="{marginInline: 'auto', marginTop: '15px'}" @save="save" @cancel="$emit('close')"/>
    </div>

  </DialogDef2>
</template>

<script>
import { getapi, postapi } from '../../store/fetch'
export default {
  props: ['rolemap', 'selected'],
  data () {
    return {
      users: [],
      userText: null,
      uldisplay: false,
      editItem: {
        name: null,
        title: null,
        erpID: null,
        department: null,
        role: 'employee',
        ref_uid: {}
      }
    }
  },
  watch: {
    userText () {
      this.getusers()
    },
    selected: {
      deep: true,
      immediate: true,
      handler () {
        this.editItem = {
          name: this.selected.name,
          title: this.selected.title,
          department: this.selected.department,
          role: this.selected.role,
          erpID: this.selected.erpID || null,
          mobile: this.selected.mobile || null,
          ref_uid: this.selected.ref_uid
        }
      }
    }
  },
  methods: {
    async getusers () {
      const users = await getapi('users/lineRef?' + new URLSearchParams({ search: this.userText }))
      this.users = users
      this.uldisplay = true
    },
    async save () {
      const item = { ...this.editItem }
      // Validate mobile number if it exists
      if (item.mobile && !this.validateMobile(item.mobile)) {
        return false
      }
      const r = await postapi(`users/local/${this.selected._id}`, item)
      if (r) {
        this.$emit('updateItem', r)
      }
    },
    validateMobile (mobile) {
      const taiwanMobileRegex = /^09\d{8}$/
      if (!taiwanMobileRegex.test(mobile)) {
        alert('請輸入09開頭10碼數字的台灣手機號碼，不允許特殊符號')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.user-box {
  width: 295px;
  text-align: start;
  padding-inline: .5em;
  border: 1px solid #B8B8B8;
  border-radius: 5px;
  height: 40px;
  display: flex;
  align-items: center;
}
.removebtn {
  margin-left: auto;
  height: 40px;
  background-color: #CACACA;
  width: 23px;
  mask-image: url(/svg/btn/close.svg);
  mask-size: 15px;
  mask-repeat: no-repeat;
  mask-position: center;
  border: none;
  outline: 1px solid #CACACA;
  box-sizing: content-box;
  padding: 0;
}
.ul {
  position: absolute;
  right: 0;
  width: 450px;
  background-color: #FFFFFF;
  max-height: 230px;
  overflow-y: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  z-index: 99;
  .li {
    padding-block: 7.25px;
    padding-inline: .75em;
    min-height: 55px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    line-height: 40px;
    text-align: start;
    &:hover {
      background-color: #CACACA;
    }
  }
}
.field {
  position: relative;
  display: grid;
  grid-template-columns: 90px 1fr;
  height: 40px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  text-align: right;
  letter-spacing: 0.05em;
  color: #787878;
  gap: 19px;
  input[type=text] {
    width: 295px;
    height: 40px;
    border: 1px solid #B8B8B8;
    border-radius: 5px;
    color: #787878;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    padding-inline: .5em;
  }
}
.addemp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 48px 88px 42px;
}
</style>
